// Asking for the quote of a case that has none: how `POST /me/cases/:id/quote`
// answers, read defensively.

export type CaseQuoteFailure = "past_dispatch" | "unavailable";

/** The quote id in a success body; null for any other shape. */
export function parseCaseQuoteId(raw: unknown): string | null {
  if (typeof raw !== "object" || raw === null) return null;
  const quoteId = (raw as Record<string, unknown>).quote_id;
  return typeof quoteId === "string" && quoteId !== "" ? quoteId : null;
}

/** A 409 means the case moved past Dispatch, so the page should reload the
 * case; everything else (422, a network error, an unreadable answer) is a
 * quote that could not be made, which the family is sent to the phone for. */
export function caseQuoteFailure(error: unknown): CaseQuoteFailure {
  const status =
    typeof error === "object" && error !== null
      ? (error as { statusCode?: unknown }).statusCode
      : undefined;
  return status === 409 ? "past_dispatch" : "unavailable";
}
